/* Clear Cut Signs / Clear Cut Customs - Custom Text Add-on Calculator */
(function () {
  function billableCount(text) {
    return (text || '')
      .replace(/\s/g, '')
      .replace(/[^a-zA-Z0-9]/g, '')
      .length;
  }

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((cents || 0) / 100);
    } catch (e) {
      return '$' + ((cents || 0) / 100).toFixed(2);
    }
  }

  function setNativeValue(input, value) {
    const previous = input.value;
    input.value = value;
    if (previous !== String(value)) {
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function lockQuantity(quantityWrapper, shouldLock) {
    if (!quantityWrapper) return;
    const buttons = quantityWrapper.querySelectorAll('button');
    buttons.forEach(function (button) {
      button.disabled = shouldLock;
      button.setAttribute('aria-disabled', shouldLock ? 'true' : 'false');
    });
    const input = quantityWrapper.querySelector('input[name="quantity"]');
    if (input) input.readOnly = shouldLock;
    quantityWrapper.classList.toggle('cc-custom-text-addon__quantity-locked', shouldLock);
  }

  function initCalculator(root) {
    if (!root || root.dataset.ccInitialized === 'true') return;
    root.dataset.ccInitialized = 'true';

    const form = root.closest('form');
    if (!form) return;

    const productForm = form.closest('product-form-component');
    const variantInput = form.querySelector('input[name="id"]');
    const quantityInput = form.querySelector('[data-cc-locked-quantity]') || form.querySelector('input[name="quantity"]');
    const quantityWrapper = form.querySelector('.quantity-selector-wrapper');

    const typeRadios = root.querySelectorAll('input[name="properties[Text Selection Type]"]');
    const popularPanel = root.querySelector('[data-cc-panel="popular"]');
    const customPanel = root.querySelector('[data-cc-panel="custom"]');
    const popularText = root.querySelector('[data-cc-popular-text]');
    const customText = root.querySelector('[data-cc-custom-text]');
    const finalText = root.querySelector('[data-cc-final-text]');
    const countProperty = root.querySelector('[data-cc-letter-count-property]');

    const summaryText = root.querySelector('[data-cc-summary-text]');
    const summaryCount = root.querySelector('[data-cc-summary-count]');
    const summaryEach = root.querySelector('[data-cc-summary-each]');
    const summaryTotal = root.querySelector('[data-cc-summary-total]');
    const svgPreviewText = root.querySelector('[data-cc-svg-preview-text]');
    const fontSelect = root.querySelector('[data-cc-font-select]');
    const fontPreview = root.querySelector('[data-cc-font-preview]');
    let latestEstimatedTotal = 0;
    let latestVariantPrice = 0;
    let mainPriceObserver = null;
    let mainPriceObserverTimer = null;

    function getMainPriceScope() {
      return (
        productForm?.closest('.shopify-section') ||
        form.closest('.shopify-section') ||
        document
      );
    }

    function updateMainProductPrice(estimatedTotal, variantPrice) {
      if (!variantPrice || !estimatedTotal) return;

      latestEstimatedTotal = estimatedTotal;
      latestVariantPrice = variantPrice;

      const formattedTotal = formatMoney(estimatedTotal);
      const scope = getMainPriceScope();

      const productPriceBlocks = scope.querySelectorAll('product-price');

      productPriceBlocks.forEach(function (priceBlock) {
        const priceContainer = priceBlock.querySelector('[ref="priceContainer"]') || priceBlock;
        const priceElements = priceContainer.querySelectorAll('.price');

        priceElements.forEach(function (el) {
          if (el && el.textContent !== formattedTotal) {
            el.textContent = formattedTotal;
            el.setAttribute('data-cc-estimated-total-price', 'true');
          }
        });
      });
    }

    function watchMainProductPrice() {
      if (mainPriceObserver) return;

      const scope = getMainPriceScope();
      const productPriceBlocks = scope.querySelectorAll('product-price');
      if (!productPriceBlocks.length) return;

      mainPriceObserver = new MutationObserver(function () {
        window.clearTimeout(mainPriceObserverTimer);
        mainPriceObserverTimer = window.setTimeout(function () {
          updateMainProductPrice(latestEstimatedTotal, latestVariantPrice);
        }, 20);
      });

      productPriceBlocks.forEach(function (priceBlock) {
        mainPriceObserver.observe(priceBlock, {
          childList: true,
          subtree: true,
          characterData: true
        });
      });
    }

    const priceScript = form.querySelector('script[type="application/json"][data-cc-variant-prices]') || document.querySelector('script[type="application/json"][data-cc-variant-prices]');
    let variantPrices = {};
    if (priceScript) {
      try { variantPrices = JSON.parse(priceScript.textContent || '{}'); } catch (e) { variantPrices = {}; }
    }

    // Prevent customers from lowering the quantity below the letter count.
    lockQuantity(quantityWrapper, true);

    function activeMode() {
      const checked = root.querySelector('input[name="properties[Text Selection Type]"]:checked');
      return checked && checked.value === 'Customize Your Own Text' ? 'custom' : 'popular';
    }

    function currentText() {
      return activeMode() === 'custom' ? (customText?.value || '') : (popularText?.value || '');
    }

    function currentVariantPrice() {
      const variantId = variantInput ? String(variantInput.value) : '';
      return Number(variantPrices[variantId] || 0);
    }

    function update() {
      const mode = activeMode();
      if (popularPanel) popularPanel.hidden = mode !== 'popular';
      if (customPanel) customPanel.hidden = mode !== 'custom';

      const text = currentText().trim();
      const count = Math.max(1, billableCount(text));
      const variantPrice = currentVariantPrice();
      const estimatedTotal = variantPrice * count;
      watchMainProductPrice();
      updateMainProductPrice(estimatedTotal, variantPrice);

      window.setTimeout(function () {
        updateMainProductPrice(estimatedTotal, variantPrice);
      }, 75);

      window.setTimeout(function () {
        updateMainProductPrice(estimatedTotal, variantPrice);
      }, 250);

      window.setTimeout(function () {
        updateMainProductPrice(estimatedTotal, variantPrice);
      }, 600);

      if (finalText) finalText.value = text;
      if (countProperty) countProperty.value = String(count);
      if (quantityInput) setNativeValue(quantityInput, count);

      if (summaryText) summaryText.textContent = text || 'Enter text';
      if (summaryCount) summaryCount.textContent = String(count);
      if (summaryEach && variantPrice) summaryEach.textContent = formatMoney(variantPrice);
      if (summaryTotal && variantPrice) summaryTotal.textContent = formatMoney(estimatedTotal);
      // Font Preview Update
        if (fontPreview && fontSelect) {

        fontPreview.textContent = text || 'GRAD';

        fontPreview.style.fontFamily = fontSelect.value;

        }
      
    if (svgPreviewText) {
  svgPreviewText.textContent = text || 'GRAD';

  if (fontSelect) {
    svgPreviewText.style.fontFamily = fontSelect.value;
  }

  const colorMap = {
    white: '#ffffff',
    red: '#ef2b2d',
    maroon: '#810404',
    pink: '#f5b6c8',
    purple: '#9b4dcc',
    orange: '#ff8a00',
    green: '#00a84f',
    gray: '#808080',
    grey: '#808080',
    brown: '#9a5b34',
    black: '#000000',
    blue: '#005fd1',
    yellow: '#ffd900'
  };

  let selectedColor = '';

  const colorOption =
    document.querySelector('[data-selected-value-for-option="Color"]') ||
    document.querySelector('[data-option-name="Color"] .selected') ||
    document.querySelector('[name*="Color"]:checked');

  if (colorOption) {
    selectedColor =
      colorOption.textContent ||
      colorOption.value ||
      colorOption.getAttribute('aria-label') ||
      '';
  }

  selectedColor = selectedColor.trim().toLowerCase();

  if (!selectedColor && variantInput) {
    const selectedVariantButton = document.querySelector('[aria-pressed="true"], .selected, [data-selected="true"]');

    if (selectedVariantButton) {
      selectedColor =
        selectedVariantButton.textContent ||
        selectedVariantButton.getAttribute('aria-label') ||
        '';
    }

    selectedColor = selectedColor.trim().toLowerCase();
  }

  const previewColor = colorMap[selectedColor] || '#ffffff';

  svgPreviewText.style.setProperty('--cc-preview-color', previewColor);
  svgPreviewText.style.fill = previewColor;
}
    }

    typeRadios.forEach(function (radio) { radio.addEventListener('change', update); });
    if (popularText) popularText.addEventListener('change', update);
    if (customText) customText.addEventListener('input', update);
    if (fontSelect) fontSelect.addEventListener('change', update);
    if (variantInput) {
      const observer = new MutationObserver(update);
      observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
      variantInput.addEventListener('change', update);
      variantInput.addEventListener('input', update);
    }
    document.addEventListener('variant:update', update, { passive: true });
    document.addEventListener('variant:change', update, { passive: true });
    document.addEventListener('variant:selected', update, { passive: true });

    // Re-check shortly after variant swatches/buttons change because some themes update hidden ID asynchronously.
    form.addEventListener('change', function () { window.setTimeout(update, 50); });
    if (productForm) productForm.addEventListener('change', function () { window.setTimeout(update, 50); });

    update();
  }

  function initAll() {
    document.querySelectorAll('[data-cc-custom-text-addon]').forEach(initCalculator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
